export default "__VITE_ASSET__DPZObY0v__"